import { render, staticRenderFns } from "./invoices_pos.vue?vue&type=template&id=866209d2"
import script from "./invoices_pos.vue?vue&type=script&lang=js"
export * from "./invoices_pos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports